"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerifiedBadge = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _index2 = require("../Icon/index.js");
var _excluded = ["title", "titleId", "desc", "descId"];
/**
 * VerifiedBadge is a special standalone icon component for exclusive use when showing that an artist is verified on Spotify.
 * This icon cannot be colorized or styilized in any other way and must use it's default azure shade.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-verifiedbadge--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/VerifiedBadge) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=7566-7283&t=s9ZDoQC7G8x5OYjx-1)
 */
var VerifiedBadge = exports.VerifiedBadge = function VerifiedBadge(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Verified account' : _ref$title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var titleTag = "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>");
  var descTag = desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  return /*#__PURE__*/_react["default"].createElement(_index2.Icon, Object.assign({
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.VerifiedBadge,
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    viewBox: "0 0 24 24",
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag).concat(descTag, "<path d=\"M10.814.5a1.658 1.658 0 012.372 0l2.512 2.572 3.595-.043a1.658 1.658 0 011.678 1.678l-.043 3.595 2.572 2.512c.667.65.667 1.722 0 2.372l-2.572 2.512.043 3.595a1.658 1.658 0 01-1.678 1.678l-3.595-.043-2.512 2.572a1.658 1.658 0 01-2.372 0l-2.512-2.572-3.595.043a1.658 1.658 0 01-1.678-1.678l.043-3.595L.5 13.186a1.658 1.658 0 010-2.372l2.572-2.512-.043-3.595a1.658 1.658 0 011.678-1.678l3.595.043L10.814.5zm6.584 9.12a1 1 0 00-1.414-1.413l-6.011 6.01-1.894-1.893a1 1 0 00-1.414 1.414l3.308 3.308 7.425-7.425z\" fill=").concat(_index.defaultTheme.announcement.background.base, "></path>")
    }
  }, props));
};